<div class="px-6 py-0 mt-6 mb-12">

  <div class="card h-full flex flex-col w-full">

    <!-- Header -->
    <div class="card p-6">
      <h3 class="text-xl font-bold !text-secondary-900 mb-3">Recommendations</h3>
      <p class="!text-secondary">
        Discover key contacts at {{ companyName || 'this company' }}.
      </p>
    </div>

    <!-- Loading State -->
    <div *ngIf="isLoading" class="card flex justify-center items-center py-8">
      <svg class="animate-spin h-6 w-6 text-blue-royal" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
      </svg>
    </div>

    <!-- Error State -->
    <div *ngIf="error && !isLoading" class="card text-center py-8">
      <div class="mx-auto w-12 h-12 bg-red-100 dark:bg-red-900/20 rounded-xl flex items-center justify-center mb-4">
        <svg class="w-6 h-6 text-red-600 dark:text-red-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
        </svg>
      </div>
      <p class="text-red-600 dark:text-red-400 text-sm">Failed to load recommendations</p>
    </div>

    <!-- No Results -->
    <div *ngIf="!isLoading && !error && recommendations.length === 0" class="card text-center py-8">
      <div class="mx-auto w-12 h-12 bg-gray-100 dark:bg-gray-800 rounded-xl flex items-center justify-center mb-4">
        <svg class="w-6 h-6 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"></path>
        </svg>
      </div>
      <p class="text-gray-500 dark:text-gray-400 text-sm">No recommendations found</p>
    </div>

    <!-- Recommendations Grid -->
    <div *ngIf="!isLoading && !error && recommendations.length > 0" class="card grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6">
      <div
        *ngFor="let person of recommendations"
        class="card p-6"
        (click)="selectPerson(person)"
      >
        <!-- Person Avatar -->
        <div class="flex justify-center mb-3">
          <img
            [src]="getPersonAvatar(person)"
            [alt]="person.name"
            class="w-12 h-12 rounded-full object-cover bg-gray-200 dark:bg-gray-600"
            (error)="onImageError($event, person.name)"
          />
        </div>

        <!-- Person Info -->
        <div class="text-center">
          <h4 class="lg:text-sm font-semibold text-gray-900 line-clamp-2 leading-tight">
            {{ person.name }}
          </h4>
          <p class="text-xs font-medium !text-gray-500 line-clamp-1" [ngClass]="{'invisible': !person.title}">
            {{ person.title ? (person.title.length > 25 ? (person.title.slice(0, 25) + '...') : person.title) : 'title' }}
          </p>

          <div *ngIf="person.organization" class="flex justify-center items-center space-x-3 mt-3">

            <!-- Company Logo -->
            <div class="flex justify-center" *ngIf="person.organization">
              <img
                [src]="getPersonCompanyLogo(person)"
                [alt]="person.organization?.name || 'Company'"
                class="w-6 h-6 rounded-md object-cover bg-gray-200 dark:bg-gray-600"
                (error)="onCompanyLogoError($event, person.organization?.name || 'Unknown Company')"
              />
            </div>

            <p *ngIf="person.organization?.name" class="text-xs font-medium text-gray-700 line-clamp-1">
              {{ person.organization.name }}
            </p>

          </div>

        </div>

        <!-- Generate / View Report Button -->
        <div class="mt-3 flex justify-center">
          <button
            type="button"
            (click)="generateReport(person, $event)"
            [disabled]="isGenerating(person)"
            class="btn btn-blue"
            [class.opacity-60]="isGenerating(person)"
            [class.cursor-not-allowed]="isGenerating(person)"
          >
            <ng-container *ngIf="isGenerating(person)">Generating...</ng-container>
            <ng-container *ngIf="isReportReady(person)">View Report</ng-container>
            <ng-container *ngIf="!isGenerating(person) && !isReportReady(person)">Generate Report</ng-container>
          </button>
        </div>
      </div>
    </div>

  </div>

</div>
